module.exports = __webpack_public_path__ + "img/combined-shape.c223bc63.svg";